export enum LprExportStatus {
  IN_PROGRESS = 'in progress',
  PENDING = 'pending',
  COMPLETE = 'complete',
  FAILED = 'failed',
}

